/* eslint-disable no-restricted-imports */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { BigNumber, Contract, utils } from 'ethers';
import { id, Interface } from 'ethers/lib/utils';
import { DEFAULT_ADDRESS } from '../../Fct/Config';
import { fctParamsFactory, GAS_LIMIT_OVERHEAD, getContractInterface, getContractInterfaceReturns, getMethodDescription, getMethodInterface, getMethodParams, toBytes32, } from '../../Fct/helpers';
import { kiroboMulticallSimulateContracts } from '../../Fct/plugins/KIROBO_MULTICALL_CSV/constants';
import { v4 } from 'uuid';
import gasLimit from '../plugins/gasLimit.json';
import { FctParam, isVariable, maxValue, } from './FctParams';
import { Input } from './Input';
import { Output } from './Output';
import { ZERO_ADDRESS } from '../../constants/misc';
import { getExternalVariable, getGlobalVariable, getOutputVariable } from './variables/getVariables';
var uid = v4();
var Plugin = /** @class */ (function () {
    function Plugin(_protocol, _type, _method, _name, chainId, params, requiredApprovals, assetFlow, initParams, _walletAddress, _vaultAddress, _provider, _flowType) {
        var _this = this;
        this._protocol = _protocol;
        this._type = _type;
        this._method = _method;
        this._name = _name;
        this.requiredApprovals = requiredApprovals;
        this.assetFlow = assetFlow;
        this._walletAddress = _walletAddress;
        this._vaultAddress = _vaultAddress;
        this._provider = _provider;
        this._flowType = _flowType;
        this.setMethod = function (method) {
            _this._method = method;
        };
        this._supportedContracts = [];
        this.calculateValuesOnUserInput = undefined;
        this.setMethodParams = function (params) {
            _this.input.setMethodParams(params);
        };
        this.setOutputParams = function (params) {
            _this.output.setOutputParams(params);
        };
        this.estimateGasOnParams = undefined;
        this.getOutputValues = function (_a) {
            var provider = _a.provider, execute = _a.execute, setEstimated = _a.setEstimated, abi = _a.abi, walletSigner = _a.walletSigner, withAutoApprovals = _a.withAutoApprovals;
            return __awaiter(_this, void 0, void 0, function () {
                var plugin, _b, inputParams, setOutputIsLoading, _c, value1, value2, operator, computeOperation, validateValueOperation1, _d, _e, error, _f, value1, value2, operator, computeOperation, validateValueOperation1, _g, _h, error, _j, value1, value2, value3, value4, operator1, operator2, operator3, computeOperation, computedValueOperation1, _k, _l, computedValueOperation2, _m, _o, computedValueOperation3, _p, _q, _r, value1, value2, value3, value4, operator1, operator2, operator3, computeOperation, computedValueOperation1, _s, _t, computedValueOperation2, _u, _v, computedValueOperation3, _w, _x, _y, to_1, value_1, parsedValue, sendEthRes, trxEthData, e_1, error, toParam, to, _z, pluginMethodInterface, contract, methodParamsToValues, valueParam, methodParamsList, value, singerAddress, trx, res, encodedData, trxData, e_2, error, outputParams, params;
                var _0;
                var _this = this;
                var _1, _2, _3, _4;
                return __generator(this, function (_5) {
                    switch (_5.label) {
                        case 0:
                            if (this.method === 'magic')
                                return [2 /*return*/, {}];
                            if (this._flowType === 'OFFCHAIN_ONLY')
                                return [2 /*return*/, {}
                                    //if (this.method === 'getImage') return {}
                                ];
                            if (!this.getParamsOnCreate) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.getParamsOnCreate({ chainId: this.chainId, params: this.input.params, isEstimation: true })];
                        case 1:
                            _b = ((_1 = (_5.sent())) === null || _1 === void 0 ? void 0 : _1.plugin) || this;
                            return [3 /*break*/, 3];
                        case 2:
                            _b = this;
                            _5.label = 3;
                        case 3:
                            plugin = (_b);
                            inputParams = plugin.input.paramsList;
                            setOutputIsLoading = function (isLoadIng) {
                                _this.output.paramsList.forEach(function (_a) {
                                    var param = _a.param;
                                    param.isLoading = isLoadIng;
                                });
                            };
                            if (!plugin.beforeSimulate) return [3 /*break*/, 5];
                            if (walletSigner && withAutoApprovals && plugin.getRequiredApprovals().length) {
                                provider.signer = walletSigner;
                            }
                            return [4 /*yield*/, plugin.beforeSimulate({
                                    provider: provider,
                                    chainId: plugin.chainId,
                                    input: plugin.input.params,
                                    output: plugin.output.params,
                                })];
                        case 4:
                            _5.sent();
                            _5.label = 5;
                        case 5:
                            this.currentGasLimit = undefined;
                            if (!(plugin.name === 'validateAnyType' && plugin.type === 'VALIDATION')) return [3 /*break*/, 8];
                            _c = plugin.input.methodParams, value1 = _c.value1, value2 = _c.value2, operator = _c.operator;
                            computeOperation = function (value1, operator, value2) {
                                switch (operator) {
                                    case 'equal':
                                        return value1 === value2 ? '1' : '0';
                                    case 'greater than':
                                        if (!value1)
                                            return '0';
                                        if (!value2)
                                            return '0';
                                        return value1 > value2 ? '1' : '0';
                                    case 'greater equal than':
                                        if (!value1)
                                            return '0';
                                        if (!value2)
                                            return '0';
                                        return value1 >= value2 ? '1' : '0';
                                    case 'or':
                                        return value1 || value2 ? '1' : '0';
                                    case 'or not':
                                        return value1 || !value2 ? '1' : '0';
                                    case 'and':
                                        return value1 && value2 ? '1' : '0';
                                    case 'and not':
                                        return value1 && !value2 ? '1' : '0';
                                    case 'not equal':
                                        return value1 !== value2 ? '1' : '0';
                                    default:
                                        return '0';
                                }
                            };
                            if (!(value1 instanceof FctParam) || !(value2 instanceof FctParam))
                                return [2 /*return*/, { result: undefined }];
                            _d = computeOperation;
                            return [4 /*yield*/, this.variableToValue(value1, provider.provider)];
                        case 6:
                            _e = [(_5.sent()),
                                operator.value];
                            return [4 /*yield*/, this.variableToValue(value2, provider.provider)];
                        case 7:
                            validateValueOperation1 = _d.apply(void 0, _e.concat([(_5.sent())]));
                            if (validateValueOperation1 === '0') {
                                error = 'validation failed';
                                this.setError(error);
                                //this.output.paramsList.forEach(({ param }) => param.setEstimated({ value: undefined }))
                                throw error;
                            }
                            this.currentGasLimit = '10000';
                            return [2 /*return*/, { result: validateValueOperation1 }];
                        case 8:
                            if (!(plugin.name === 'validate' && plugin.type === 'VALIDATION')) return [3 /*break*/, 11];
                            _f = plugin.input.methodParams, value1 = _f.value1, value2 = _f.value2, operator = _f.operator;
                            computeOperation = function (value1, operator, value2) {
                                switch (operator) {
                                    case 'equal':
                                        return value1 === value2 ? '1' : '0';
                                    case 'greater than':
                                        return BigNumber.from(value1 || '0').gt(value2 || '0') ? '1' : '0';
                                    case 'greater equal than':
                                        return BigNumber.from(value1 || '0').gte(value2 || '0') ? '1' : '0';
                                    case 'or':
                                        return Boolean(value1) || Boolean(value2) ? '1' : '0';
                                    case 'or not':
                                        return Boolean(value1) || !Boolean(value2) ? '1' : '0';
                                    case 'and':
                                        return Boolean(value1) && Boolean(value2) ? '1' : '0';
                                    case 'and not':
                                        return Boolean(value1) && !Boolean(value2) ? '1' : '0';
                                    case 'not equal':
                                        return value1 !== value2 ? '1' : '0';
                                    default:
                                        return '0';
                                }
                            };
                            _g = computeOperation;
                            return [4 /*yield*/, this.variableToValue(value1, provider.provider)];
                        case 9:
                            _h = [(_5.sent()),
                                operator.value];
                            return [4 /*yield*/, this.variableToValue(value2, provider.provider)];
                        case 10:
                            validateValueOperation1 = _g.apply(void 0, _h.concat([(_5.sent())]));
                            if (validateValueOperation1 === '0') {
                                error = 'validation failed';
                                this.setError(error);
                                //this.output.paramsList.forEach(({ param }) => param.setEstimated({ value: undefined }))
                                throw error;
                            }
                            this.currentGasLimit = '10000';
                            return [2 /*return*/, { result: validateValueOperation1 }];
                        case 11:
                            if (!(plugin.name === 'computeHash' && plugin.type === 'COMPUTED')) return [3 /*break*/, 16];
                            _j = plugin.input.methodParams, value1 = _j.value1, value2 = _j.value2, value3 = _j.value3, value4 = _j.value4, operator1 = _j.operator1, operator2 = _j.operator2, operator3 = _j.operator3;
                            computeOperation = function (value1, operator, value2, value1Type, value2Type) {
                                console.log({ value2Type: value2Type });
                                var parsedValue1Type = value1Type === 'bytes32' || value1Type === 'string' || value1Type === 'anyType' ? 'bytes32' : 'uint256';
                                var parsedValue2Type = value2Type === 'bytes32' || value2Type === 'string' || value2Type === 'anyType' ? 'bytes32' : 'uint256';
                                var parsedValue1 = parsedValue1Type === 'bytes32' ? toBytes32(value1) : value1;
                                var parsedValue2 = parsedValue2Type === 'bytes32' ? toBytes32(value2) : value2;
                                switch (operator) {
                                    case 'keccak256':
                                        if (!value1 || (Number(value1) === 0 && typeof value2 === 'string')) {
                                            return utils.solidityKeccak256([parsedValue2Type], [parsedValue2]);
                                        }
                                        if (!value2 || (Number(value2) === 0 && typeof value1 === 'string')) {
                                            return utils.solidityKeccak256([parsedValue1Type], [parsedValue1]);
                                        }
                                        return utils.solidityKeccak256([parsedValue1Type, parsedValue2Type], [parsedValue1, parsedValue2]);
                                    default:
                                        return value2;
                                }
                            };
                            if (!(value1 instanceof FctParam) || !(value2 instanceof FctParam))
                                return [2 /*return*/, { result: undefined }];
                            _k = computeOperation;
                            return [4 /*yield*/, this.variableToValue(value1, provider === null || provider === void 0 ? void 0 : provider.provider)];
                        case 12:
                            _l = [(_5.sent()),
                                operator1.value];
                            return [4 /*yield*/, this.variableToValue(value2, provider === null || provider === void 0 ? void 0 : provider.provider)];
                        case 13:
                            computedValueOperation1 = _k.apply(void 0, _l.concat([(_5.sent()),
                                value1.uiType || value1.fctType,
                                value2.uiType || value2.fctType]));
                            this.currentGasLimit = '10000';
                            if (!operator2.value)
                                return [2 /*return*/, { result: computedValueOperation1 }];
                            if (!(value3 instanceof FctParam))
                                return [2 /*return*/, { result: computedValueOperation1 }];
                            _m = computeOperation;
                            _o = [computedValueOperation1,
                                operator2.value];
                            return [4 /*yield*/, this.variableToValue(value3, provider.provider)];
                        case 14:
                            computedValueOperation2 = _m.apply(void 0, _o.concat([(_5.sent()),
                                value2.uiType || value2.fctType,
                                value3.uiType || value3.fctType]));
                            if (!operator3.value)
                                return [2 /*return*/, { result: computedValueOperation2 }];
                            if (!(value4 instanceof FctParam))
                                return [2 /*return*/, { result: computedValueOperation2 }];
                            _p = computeOperation;
                            _q = [computedValueOperation2,
                                operator3.value];
                            return [4 /*yield*/, this.variableToValue(value4, provider.provider)];
                        case 15:
                            computedValueOperation3 = _p.apply(void 0, _q.concat([(_5.sent()),
                                value3.uiType || value3.fctType,
                                value4.uiType || value4.fctType]));
                            return [2 /*return*/, { result: computedValueOperation3 }];
                        case 16:
                            if (!(plugin.name === 'compute' && plugin.type === 'COMPUTED')) return [3 /*break*/, 21];
                            _r = plugin.input.methodParams, value1 = _r.value1, value2 = _r.value2, value3 = _r.value3, value4 = _r.value4, operator1 = _r.operator1, operator2 = _r.operator2, operator3 = _r.operator3;
                            computeOperation = function (value1, operator, value2) {
                                switch (operator) {
                                    case '*':
                                        return BigNumber.from(value1 || '0')
                                            .mul(value2 || '0')
                                            .toString();
                                    case '**':
                                        return BigNumber.from(value1 || '0')
                                            .pow(value2 || '0')
                                            .toString();
                                    case '*(10**X)':
                                        return BigNumber.from(value1 || '0')
                                            .mul(BigNumber.from('10').pow(value2 || '0'))
                                            .toString();
                                    case '/(10**X)':
                                        return BigNumber.from(value1 || '0')
                                            .div(BigNumber.from('10').pow(value2 || '0'))
                                            .toString();
                                    case '%':
                                        return BigNumber.from(value1 || '0')
                                            .mod(value2 || '0')
                                            .toString();
                                    case '/':
                                        if (!value2)
                                            return BigNumber.from('0').toString();
                                        return BigNumber.from(value1 || '0')
                                            .div(value2)
                                            .toString();
                                    case '-':
                                        return BigNumber.from(value1 || '0')
                                            .sub(value2 || '0')
                                            .toString();
                                    case 'max':
                                        return BigNumber.from(value1 || '0').gte(value2 || '0') ? value1 : value2;
                                    case 'min':
                                        return BigNumber.from(value1 || '0').lte(value2 || '0') ? value1 : value2;
                                    case '+':
                                        return BigNumber.from(value1 || '0')
                                            .add(value2 || '0')
                                            .toString();
                                    default:
                                        return BigNumber.from(value1 || '0')
                                            .add(value2 || '0')
                                            .toString();
                                }
                            };
                            _s = computeOperation;
                            return [4 /*yield*/, this.variableToValue(value1, provider.provider)];
                        case 17:
                            _t = [(_5.sent()),
                                operator1.value];
                            return [4 /*yield*/, this.variableToValue(value2, provider.provider)];
                        case 18:
                            computedValueOperation1 = _s.apply(void 0, _t.concat([(_5.sent())]));
                            _u = computeOperation;
                            _v = [computedValueOperation1,
                                operator2.value];
                            return [4 /*yield*/, this.variableToValue(value3, provider.provider)];
                        case 19:
                            computedValueOperation2 = _u.apply(void 0, _v.concat([(_5.sent())]));
                            _w = computeOperation;
                            _x = [computedValueOperation2,
                                operator3.value];
                            return [4 /*yield*/, this.variableToValue(value4, provider.provider)];
                        case 20:
                            computedValueOperation3 = _w.apply(void 0, _x.concat([(_5.sent())]));
                            this.currentGasLimit = '10000';
                            return [2 /*return*/, { result: computedValueOperation3 }];
                        case 21:
                            if (!(plugin.name === 'sendETH')) return [3 /*break*/, 27];
                            setOutputIsLoading(true);
                            _y = plugin.input.params, to_1 = _y.to, value_1 = _y.value;
                            return [4 /*yield*/, plugin.variableToValue(value_1, provider.provider)];
                        case 22:
                            parsedValue = _5.sent();
                            _5.label = 23;
                        case 23:
                            _5.trys.push([23, 26, , 27]);
                            return [4 /*yield*/, provider.signer.sendTransaction({
                                    to: to_1 === null || to_1 === void 0 ? void 0 : to_1.value,
                                    value: parsedValue,
                                })];
                        case 24:
                            sendEthRes = _5.sent();
                            return [4 /*yield*/, provider.provider.getTransaction(sendEthRes.hash)];
                        case 25:
                            trxEthData = _5.sent();
                            setOutputIsLoading(false);
                            this.currentGasLimit = trxEthData.gasLimit.sub(21000).toString();
                            return [2 /*return*/, {}];
                        case 26:
                            e_1 = _5.sent();
                            error = new Error(e_1);
                            this.setError(e_1.reason || e_1.message || e_1);
                            //this.output.paramsList.forEach(({ param }) => param.setEstimated({ value: undefined }))
                            setOutputIsLoading(false);
                            throw error;
                        case 27:
                            toParam = (_2 = inputParams.find(function (_a) {
                                var key = _a.key;
                                return key === 'to';
                            })) === null || _2 === void 0 ? void 0 : _2.param;
                            if (!(plugin.protocol === 'KIROBO_MULTICALL_CSV')) return [3 /*break*/, 28];
                            _z = kiroboMulticallSimulateContracts[plugin.chainId];
                            return [3 /*break*/, 30];
                        case 28: return [4 /*yield*/, plugin.variableToValue(toParam, provider.provider)];
                        case 29:
                            _z = _5.sent();
                            _5.label = 30;
                        case 30:
                            to = _z;
                            if (typeof to !== 'string') {
                                return [2 /*return*/, "invalid contract address: ".concat(to)];
                            }
                            pluginMethodInterface = new utils.Interface([
                                "function ".concat(plugin.contractInterface, " payable ").concat(plugin.contractInterfaceReturns),
                            ]);
                            contract = abi
                                ? new Contract(to, abi, provider.signer)
                                : new Contract(to, pluginMethodInterface, provider.signer);
                            setOutputIsLoading(true);
                            methodParamsToValues = function (methodParams) { return __awaiter(_this, void 0, void 0, function () {
                                var list, methodParams_1, methodParams_1_1, param, value_2, _a, _b, value_3, coder, e_3_1;
                                var e_3, _c;
                                return __generator(this, function (_d) {
                                    switch (_d.label) {
                                        case 0:
                                            list = [];
                                            _d.label = 1;
                                        case 1:
                                            _d.trys.push([1, 8, 9, 10]);
                                            methodParams_1 = __values(methodParams), methodParams_1_1 = methodParams_1.next();
                                            _d.label = 2;
                                        case 2:
                                            if (!!methodParams_1_1.done) return [3 /*break*/, 7];
                                            param = methodParams_1_1.value;
                                            if (param.type === 'tuple[]') {
                                                value_2 = param.value;
                                                list.push(value_2 === null || value_2 === void 0 ? void 0 : value_2.map(function (nestedParam) { return nestedParam.map(function (p) { return p.value; }); }));
                                                return [3 /*break*/, 6];
                                            }
                                            if (!(typeof param.type === 'string' && param.type.includes('tuple'))) return [3 /*break*/, 4];
                                            _b = (_a = list).push;
                                            return [4 /*yield*/, methodParamsToValues(param.value)];
                                        case 3:
                                            _b.apply(_a, [_d.sent()]);
                                            return [3 /*break*/, 6];
                                        case 4:
                                            if (param.virtual)
                                                return [3 /*break*/, 6];
                                            if (!param.value) {
                                                list.push(param.value);
                                                return [3 /*break*/, 6];
                                            }
                                            return [4 /*yield*/, plugin.variableToValue(param, provider.provider)];
                                        case 5:
                                            value_3 = _d.sent();
                                            if (param.type === 'bytes32' && param.messageType === 'string' && typeof param.value === 'string') {
                                                value_3 = utils.id(param.value);
                                            }
                                            if (param.type === 'bytes' && param.messageType === 'string' && typeof param.value === 'string') {
                                                coder = utils.defaultAbiCoder;
                                                value_3 = coder.encode(['string'], [param.value]);
                                            }
                                            list.push(value_3);
                                            _d.label = 6;
                                        case 6:
                                            methodParams_1_1 = methodParams_1.next();
                                            return [3 /*break*/, 2];
                                        case 7: return [3 /*break*/, 10];
                                        case 8:
                                            e_3_1 = _d.sent();
                                            e_3 = { error: e_3_1 };
                                            return [3 /*break*/, 10];
                                        case 9:
                                            try {
                                                if (methodParams_1_1 && !methodParams_1_1.done && (_c = methodParams_1.return)) _c.call(methodParams_1);
                                            }
                                            finally { if (e_3) throw e_3.error; }
                                            return [7 /*endfinally*/];
                                        case 10: return [2 /*return*/, list];
                                    }
                                });
                            }); };
                            valueParam = (_3 = inputParams.find(function (_a) {
                                var key = _a.key;
                                return key === 'value';
                            })) === null || _3 === void 0 ? void 0 : _3.param;
                            return [4 /*yield*/, methodParamsToValues(plugin.methodParams)];
                        case 31:
                            methodParamsList = _5.sent();
                            value = !(valueParam === null || valueParam === void 0 ? void 0 : valueParam.value) ? '0x0' : valueParam.isVariable ? valueParam.estimatedValue : valueParam.value;
                            return [4 /*yield*/, provider.signer.getAddress()];
                        case 32:
                            singerAddress = _5.sent();
                            _5.label = 33;
                        case 33:
                            _5.trys.push([33, 38, , 39]);
                            console.log({ methodParamsValues: methodParamsList, method: plugin.method });
                            if ((_4 = methodParamsList.filter(function (value) { return value === null || value === undefined; })) === null || _4 === void 0 ? void 0 : _4.length) {
                                this.setError(undefined);
                                setOutputIsLoading(false);
                                throw "wrong method params";
                            }
                            return [4 /*yield*/, (_0 = contract.callStatic)[plugin.method].apply(_0, __spreadArray(__spreadArray([], __read(methodParamsList), false), [{
                                        from: singerAddress,
                                        value: value,
                                    }], false))];
                        case 34:
                            trx = (_5.sent());
                            if (!(trx && execute)) return [3 /*break*/, 37];
                            return [4 /*yield*/, contract[plugin.method].apply(contract, __spreadArray(__spreadArray([], __read(methodParamsList), false), [{
                                        from: singerAddress,
                                        value: value,
                                    }], false))];
                        case 35:
                            res = _5.sent();
                            encodedData = pluginMethodInterface.encodeFunctionData(plugin.method, methodParamsList);
                            return [4 /*yield*/, provider.provider.getTransaction(res.hash)];
                        case 36:
                            trxData = _5.sent();
                            this.currentGasLimit = trxData.gasLimit
                                .add(GAS_LIMIT_OVERHEAD)
                                .add(encodedData.length - 10)
                                .mul(115)
                                .div(100)
                                .toString();
                            _5.label = 37;
                        case 37:
                            this.setError(undefined);
                            setOutputIsLoading(false);
                            return [3 /*break*/, 39];
                        case 38:
                            e_2 = _5.sent();
                            error = new Error("warning: ".concat(e_2, " ").concat(plugin.protocol, " ").concat(plugin.type, " ").concat(plugin.name, " params: ").concat(methodParamsList));
                            this.setError(e_2.reason || e_2.message || e_2);
                            setOutputIsLoading(false);
                            throw error;
                        case 39:
                            outputParams = trx //pluginMethodInterface.decodeFunctionResult(this.method, receipt.logsBloom)
                            ;
                            if (Object.keys(this.output.params).length === 1) {
                                outputParams = [outputParams];
                            }
                            params = {};
                            Object.keys(this.output.params).forEach(function (key, i) {
                                var setParam = function (outputParam) {
                                    var currentOutputParam = outputParams[i];
                                    if (key.includes("tuple") &&
                                        !key.includes("tuple[]") &&
                                        typeof currentOutputParam === 'object' &&
                                        !(currentOutputParam instanceof BigNumber)) {
                                        var tupleParam_1 = currentOutputParam;
                                        Object.keys(outputParam).forEach(function (key) {
                                            params[key] = tupleParam_1[key].toString();
                                        });
                                    }
                                    if (key.includes("tuple[]") &&
                                        typeof currentOutputParam === 'object' &&
                                        !(currentOutputParam instanceof BigNumber)) {
                                        params[outputKey] = currentOutputParam.map(function (p) {
                                            var tupleParam = p;
                                            var paramObject = {};
                                            Object.keys(outputParam).forEach(function (key) {
                                                paramObject[key] = tupleParam[key];
                                            });
                                            return paramObject;
                                        });
                                    }
                                    if (!(outputParam instanceof FctParam))
                                        return;
                                    var value = outputParams[i] ? outputParams[i].toString() : undefined;
                                    params[outputKey] = value;
                                    outputParam.setEstimated({ value: value });
                                };
                                var outputKey = key;
                                var outputParam = _this.output.params[outputKey];
                                setParam(outputParam);
                            });
                            return [2 /*return*/, params];
                    }
                });
            });
        };
        this.getCalldata = function (isEstimation, testProvider) { return __awaiter(_this, void 0, void 0, function () {
            var inputParams, to, getVariableValue, methodParamsToValues, trxParams, trxParamsValues, trxParamsTypes, abiCoder, getEthValue, ethValue, callType;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        inputParams = this.input.params;
                        to = (_a = inputParams.to) === null || _a === void 0 ? void 0 : _a.value;
                        if (typeof to !== 'string') {
                            console.error("invalid contract address: ".concat(to));
                            return [2 /*return*/];
                        }
                        getVariableValue = function (variable, paramType) {
                            switch (variable.type) {
                                case 'output':
                                    return getOutputVariable({
                                        index: variable.id.index || 0,
                                        offset: variable.id.innerIndex,
                                        type: paramType,
                                    });
                                case 'global':
                                    return getGlobalVariable({
                                        id: variable.id,
                                        type: paramType,
                                    });
                                case 'external':
                                    return getExternalVariable({
                                        index: variable.id || 0,
                                        type: paramType,
                                    });
                                default:
                                    console.error('variable type not supported');
                                    return;
                            }
                        };
                        methodParamsToValues = function (methodParams) { return __awaiter(_this, void 0, void 0, function () {
                            var list, methodParams_2, methodParams_2_1, param, value_4, _a, _b, value, _c, variable, variableValue, coder, e_4_1;
                            var e_4, _d;
                            return __generator(this, function (_e) {
                                switch (_e.label) {
                                    case 0:
                                        list = { params: [], types: [] };
                                        _e.label = 1;
                                    case 1:
                                        _e.trys.push([1, 10, 11, 12]);
                                        methodParams_2 = __values(methodParams), methodParams_2_1 = methodParams_2.next();
                                        _e.label = 2;
                                    case 2:
                                        if (!!methodParams_2_1.done) return [3 /*break*/, 9];
                                        param = methodParams_2_1.value;
                                        if (param.type === 'tuple[]') {
                                            value_4 = param.value;
                                            list.params.push(value_4 === null || value_4 === void 0 ? void 0 : value_4.map(function (nestedParam) { return nestedParam.map(function (p) { return p.value; }); }));
                                            list.types.push(param.type);
                                            return [3 /*break*/, 8];
                                        }
                                        if (!(typeof param.type === 'string' && param.type.includes('tuple'))) return [3 /*break*/, 4];
                                        _b = (_a = list.params).push;
                                        return [4 /*yield*/, methodParamsToValues(param.value)];
                                    case 3:
                                        _b.apply(_a, [_e.sent()]);
                                        return [3 /*break*/, 8];
                                    case 4:
                                        if (param.virtual)
                                            return [3 /*break*/, 8];
                                        if (!param.value) {
                                            list.params.push(param.value);
                                            list.types.push(param.type);
                                            return [3 /*break*/, 8];
                                        }
                                        if (!(isEstimation && testProvider)) return [3 /*break*/, 6];
                                        return [4 /*yield*/, this.variableToValue(param, testProvider)];
                                    case 5:
                                        _c = _e.sent();
                                        return [3 /*break*/, 7];
                                    case 6:
                                        _c = param.value;
                                        _e.label = 7;
                                    case 7:
                                        value = _c;
                                        if (!isEstimation && isVariable(param.value)) {
                                            variable = value;
                                            variableValue = getVariableValue(variable, param.type);
                                            list.params.push(variableValue);
                                            list.types.push(param.type);
                                            return [3 /*break*/, 8];
                                        }
                                        if (param.type === 'bytes32' && param.messageType === 'string' && typeof param.value === 'string') {
                                            value = utils.id(param.value);
                                        }
                                        if (param.type === 'bytes' && param.messageType === 'string' && typeof param.value === 'string') {
                                            coder = utils.defaultAbiCoder;
                                            value = coder.encode(['string'], [param.value]);
                                        }
                                        list.params.push(value);
                                        list.types.push(param.type);
                                        _e.label = 8;
                                    case 8:
                                        methodParams_2_1 = methodParams_2.next();
                                        return [3 /*break*/, 2];
                                    case 9: return [3 /*break*/, 12];
                                    case 10:
                                        e_4_1 = _e.sent();
                                        e_4 = { error: e_4_1 };
                                        return [3 /*break*/, 12];
                                    case 11:
                                        try {
                                            if (methodParams_2_1 && !methodParams_2_1.done && (_d = methodParams_2.return)) _d.call(methodParams_2);
                                        }
                                        finally { if (e_4) throw e_4.error; }
                                        return [7 /*endfinally*/];
                                    case 12: return [2 /*return*/, list];
                                }
                            });
                        }); };
                        return [4 /*yield*/, methodParamsToValues(this.methodParams)];
                    case 1:
                        trxParams = _b.sent();
                        trxParamsValues = trxParams.params.map(function (value) {
                            return value;
                        });
                        trxParamsTypes = trxParams.types.map(function (type) {
                            return type;
                        });
                        abiCoder = new utils.AbiCoder();
                        getEthValue = function () {
                            var valueParam = _this.input.params.value;
                            if (!valueParam)
                                return '0x0';
                            if (valueParam.isVariable && isEstimation)
                                return valueParam.estimatedValue || valueParam.value || '0x0';
                            if (valueParam.isVariable)
                                return getVariableValue(valueParam.value, valueParam.fctType) || '0x0';
                            return valueParam.value || '0x0';
                        };
                        ethValue = abiCoder.encode(['uint256'], [getEthValue()]);
                        callType = this.type === 'LIBRARY:VIEWONLY' || this.type === 'GETTER' || this.type === 'ORACLE' ? 'view only' : 'action';
                        return [2 /*return*/, {
                                target: { value: to, type: 'address' },
                                callType: { value: utils.id(callType), type: 'bytes32' },
                                value: {
                                    value: ethValue,
                                    type: 'uint256',
                                },
                                method: { value: utils.id(this.methodInterface), type: 'bytes32' },
                                data: { value: abiCoder.encode(trxParamsTypes, trxParamsValues), type: 'bytes' },
                            }];
                }
            });
        }); };
        this.variableToValue = function (param, provider) { return __awaiter(_this, void 0, void 0, function () {
            var value, valueId, _a, blockNumber, block, blockTimestamp, blockNumberNum, gasPrice;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        value = param.value;
                        if (typeof value === 'object' &&
                            (value.type === 'output' || value.type === 'computed' || value.type === 'validation')) {
                            return [2 /*return*/, param.estimatedValue];
                        }
                        if (!(typeof value === 'object' && 'id' in value)) return [3 /*break*/, 14];
                        valueId = value.id;
                        _a = valueId;
                        switch (_a) {
                            case 'blockTimestamp': return [3 /*break*/, 1];
                            case 'blockNumber': return [3 /*break*/, 4];
                            case 'gasPrice': return [3 /*break*/, 6];
                            case 'minerAddress': return [3 /*break*/, 8];
                            case 'originAddress': return [3 /*break*/, 9];
                            case 'flowHash': return [3 /*break*/, 10];
                            case 'maxUint': return [3 /*break*/, 11];
                            case 'chainId': return [3 /*break*/, 12];
                        }
                        return [3 /*break*/, 13];
                    case 1: return [4 /*yield*/, provider.getBlockNumber()];
                    case 2:
                        blockNumber = _b.sent();
                        return [4 /*yield*/, provider.getBlock(blockNumber)];
                    case 3:
                        block = _b.sent();
                        blockTimestamp = block.timestamp + 1000;
                        return [2 /*return*/, String(blockTimestamp)];
                    case 4: return [4 /*yield*/, provider.getBlockNumber()];
                    case 5:
                        blockNumberNum = (_b.sent()) + 1000;
                        return [2 /*return*/, String(blockNumberNum)];
                    case 6: return [4 /*yield*/, provider.getGasPrice()];
                    case 7:
                        gasPrice = _b.sent();
                        return [2 /*return*/, gasPrice.toString()];
                    case 8: return [2 /*return*/, DEFAULT_ADDRESS];
                    case 9: return [2 /*return*/, DEFAULT_ADDRESS];
                    case 10: return [2 /*return*/, '0'];
                    case 11: return [2 /*return*/, maxValue];
                    case 12: return [2 /*return*/, this.chainId];
                    case 13: return [2 /*return*/, ZERO_ADDRESS];
                    case 14:
                        if (!(typeof value === 'object' && !value.length)) return [3 /*break*/, 16];
                        return [4 /*yield*/, Promise.all(Object.keys(value).map(function (key) { return __awaiter(_this, void 0, void 0, function () {
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            _a = value;
                                            _b = key.replace('_tuple', '').replace('{}', '');
                                            return [4 /*yield*/, this.variableToValue(param.value[key], provider)];
                                        case 1:
                                            _a[_b] = _c.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 15:
                        _b.sent();
                        _b.label = 16;
                    case 16: return [2 /*return*/, value];
                }
            });
        }); };
        this.getRequiredApprovals = function (isEstimation) {
            if (_this.requiredApprovals) {
                // TODO: this.requiredApprovals to Promise function
                return _this.requiredApprovals(_this.input.get(), _this.chainId, _this.walletAddress, _this.vaultAddress, _this.provider, _this.method, isEstimation).map(function (data) {
                    var params = Object.keys(data.params).map(function (key) {
                        var dataKey = key;
                        return data.params[dataKey];
                    });
                    var getToValue = function () {
                        var _a;
                        if (!isEstimation)
                            return data.to;
                        var estimatedValue = (_a = _this.input.params.to) === null || _a === void 0 ? void 0 : _a.estimatedValue;
                        if (isVariable(data.to) && typeof estimatedValue === 'string')
                            return estimatedValue;
                        return data.to;
                    };
                    return {
                        to: getToValue(),
                        from: data.from,
                        protocol: data.protocol,
                        method: data.method,
                        params: params,
                    };
                });
            }
            return [];
        };
        this.getAssetFlow = function () {
            if (!_this.assetFlow)
                return [];
            return _this.assetFlow(_this.input.get(), _this.chainId, _this.walletAddress, _this.vaultAddress, _this.provider, _this.method);
        };
        this.subscribe = function (_a) {
            var callback = _a.callback, id = _a.id;
            _this.observers.set(id, callback);
        };
        this.unsubscribe = function (_a) {
            var id = _a.id;
            _this.observers.delete(id);
        };
        this.updateSubscriptions = function () {
            var e_5, _a;
            try {
                for (var _b = __values(_this.observers), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var observer = _c.value;
                    observer[1](_this.toJSON(), _this.error, _this.chainId, _this._currentGasLimit);
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_5) throw e_5.error; }
            }
        };
        this.observers = new Map();
        this.alerts = undefined;
        this.resetAlerts = function () {
            _this.alerts = undefined;
            _this.updateSubscriptions();
        };
        this.getAlerts = function () {
            return _this.alerts;
        };
        this.setAlert = function (alert) {
            if (!_this.alerts) {
                _this.alerts = [];
            }
            _this.alerts.push(alert);
            _this.updateSubscriptions();
        };
        var newParams = fctParamsFactory.create(params);
        this.input = new Input(newParams, chainId);
        this.chainId = chainId;
        if (initParams)
            this.input.set(initParams);
        this.output = new Output(newParams['output'], chainId);
        this.initMethodParams = this.methodParams;
        this.input.subscribe({ callback: this.updateSubscriptions, id: uid });
        this.output.subscribe({ callback: this.updateSubscriptions, id: uid });
    }
    Plugin.prototype.create = function (_a) {
        var call = _a.call;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                if (!this.input.isValid) {
                    console.error(this.input.errors);
                    return [2 /*return*/, undefined];
                }
                return [2 /*return*/, call];
            });
        });
    };
    Object.defineProperty(Plugin.prototype, "gasLimit", {
        get: function () {
            if (this.currentGasLimit)
                return this.currentGasLimit;
            if (this.estimateGasOnParams)
                return this.estimateGasOnParams(this.input.get(), this.method, this.chainId);
            var limits = gasLimit[this.chainId];
            var protocolLimits = limits[this.protocol];
            if (protocolLimits) {
                return protocolLimits[this.method] !== 'FAILED' ? protocolLimits[this.method] : undefined;
            }
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Plugin.prototype, "type", {
        get: function () {
            return this._type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Plugin.prototype, "protocol", {
        get: function () {
            return this._protocol;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Plugin.prototype, "method", {
        get: function () {
            return this._method;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Plugin.prototype, "provider", {
        get: function () {
            return this._provider;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Plugin.prototype, "walletAddress", {
        get: function () {
            return this._walletAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Plugin.prototype, "vaultAddress", {
        get: function () {
            return this._vaultAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Plugin.prototype, "name", {
        get: function () {
            if (this._name)
                return this._name;
            return this.method;
        },
        enumerable: false,
        configurable: true
    });
    Plugin.prototype.setName = function (name) {
        this._name = name;
        this.updateSubscriptions();
    };
    Object.defineProperty(Plugin.prototype, "description", {
        get: function () {
            if (this._description)
                return this._description;
            return getMethodDescription({
                protocol: this.protocol,
                type: this.type,
                methodInterface: this.methodInterface,
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Plugin.prototype, "supportedContracts", {
        get: function () {
            return this._supportedContracts;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Plugin.prototype, "falseMeansFail", {
        get: function () {
            return this._falseMeansFail || false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Plugin.prototype, "usePureMethod", {
        get: function () {
            return this._usePureMethod || false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Plugin.prototype, "methodParams", {
        get: function () {
            var params = this.input.methodParams;
            return getMethodParams({ params: params });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Plugin.prototype, "outputParams", {
        get: function () {
            var params = this.output.params;
            return getMethodParams({ params: params });
        },
        enumerable: false,
        configurable: true
    });
    Plugin.prototype.getMethodParams = function (_a) {
        var params = _a.params;
        // const params = this.input.methodParams
        return getMethodParams({ params: params });
    };
    Object.defineProperty(Plugin.prototype, "contractInterface", {
        get: function () {
            return getContractInterface({ method: this.method, params: this.methodParams });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Plugin.prototype, "contractInterfaceReturns", {
        get: function () {
            return getContractInterfaceReturns({ params: this.output.params });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Plugin.prototype, "methodInterface", {
        get: function () {
            return getMethodInterface({ method: this.method, params: this.initMethodParams });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Plugin.prototype, "methodInterfaceHash", {
        get: function () {
            return id(this.methodInterface);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Plugin.prototype, "abi", {
        get: function () {
            var _this = this;
            var pluginInterface = new Interface([
                "function ".concat(this.contractInterface, " ").concat(this.type === 'GETTER'
                    ? 'view'
                    : 'inputWithMeta' in this &&
                        this.inputWithMeta &&
                        typeof this.inputWithMeta === 'object' &&
                        'value' in this.inputWithMeta
                        ? 'payable'
                        : 'nonpayable', " ").concat(this.contractInterfaceReturns),
            ]);
            var abi = Object.keys(pluginInterface.functions).map(function (key) {
                var _a;
                var abiFunction = pluginInterface.functions[key];
                var newInputs = _this.methodParams;
                var newOutputs = _this.outputParams;
                // const newInputs = inputs.map((input) => {
                return __assign(__assign({}, abiFunction), { protocol: _this.protocol, method: _this.method, contractAddress: (_a = _this.input.params.to) === null || _a === void 0 ? void 0 : _a.value, inputs: newInputs, outputs: newOutputs });
            });
            return abi;
        },
        set: function (abiInterface) {
            var _this = this;
            var _a;
            var pluginAbi = abiInterface.find(function (func) { return func.method === _this.method; });
            if (!pluginAbi)
                return;
            var inputsToValues = function (input) {
                if (!input.value)
                    return '';
                if (typeof input.value === 'object' && input.value.length && typeof input.value[0] === 'object') {
                    return input.value.map(function (nestedInput) { return inputsToValues(nestedInput); });
                }
                return input.value;
            };
            var inputValues = pluginAbi.inputs.map(function (input) { return inputsToValues(input); });
            this.setMethodParams(inputValues, this.method);
            if (pluginAbi.contractAddress) {
                (_a = this.input.params.to) === null || _a === void 0 ? void 0 : _a.set({ value: pluginAbi.contractAddress });
            }
        },
        enumerable: false,
        configurable: true
    });
    Plugin.prototype.toJSONWithMeta = function () {
        var input = this.inputParamsTo('META');
        var output = this.outputParamsTo('META');
        var json = JSON.stringify({
            type: this.type,
            name: this.name,
            protocol: this.protocol,
            method: this.method,
            methodInterface: this.methodInterface,
            methodInterfaceHash: this.methodInterfaceHash,
            contractInterface: this.contractInterface,
            contractInterfaceReturns: this.contractInterfaceReturns,
            input: input,
            output: output,
            _flowType: this._flowType,
        });
        return json;
    };
    Plugin.prototype.fromJSONWithMeta = function (jsonWithMeta) {
        var pluginJson = JSON.parse(jsonWithMeta);
        if (!pluginJson.input) {
            console.error('wrong json format');
            return false;
        }
        try {
            if (pluginJson.name)
                this._name = pluginJson.name;
            var params_1 = pluginJson.inputList;
            this.input.paramsList.forEach(function (_a) {
                var param = _a.param, key = _a.key;
                var data = params_1.find(function (param) { return param.key === key; });
                if (data)
                    param.setJsonParam(data);
            });
            var outParams_1 = pluginJson.outputList;
            this.output.paramsList.forEach(function (_a) {
                var param = _a.param, key = _a.key;
                var data = outParams_1.find(function (param) { return param.key === key; });
                if (data)
                    param.setJsonParam(data);
            });
            this.input.updateSubscriptions();
            return true;
        }
        catch (e) {
            console.error(this.input.errors);
            return false;
        }
    };
    Plugin.prototype.toJSON = function () {
        var input = this.inputParamsTo('VALUES');
        var output = this.outputParamsTo('VALUES');
        var inputWithMeta = this.inputParamsTo('META');
        var outputWithMeta = this.outputParamsTo('META');
        var paramsList = this.input.paramsList;
        var inputList = paramsList.map(function (_a) {
            var key = _a.key, param = _a.param;
            var data = param.getJsonParam({ key: key, ioType: 'INPUT' });
            return data;
        });
        var outputList = this.output.paramsList.map(function (_a) {
            var key = _a.key, param = _a.param;
            var data = param.getJsonParam({ key: key, ioType: 'OUTPUT' });
            return data;
        });
        var json = JSON.stringify({
            type: this.type,
            name: this.name,
            protocol: this.protocol,
            method: this.method,
            methodInterface: this.methodInterface,
            methodInterfaceHash: this.methodInterfaceHash,
            contractInterface: this.contractInterface,
            contractInterfaceReturns: this.contractInterfaceReturns,
            input: input,
            output: output,
            inputWithMeta: inputWithMeta,
            outputWithMeta: outputWithMeta,
            inputList: inputList,
            outputList: outputList,
            alerts: this.alerts,
            _flowType: this._flowType,
        });
        return json;
    };
    Plugin.prototype.fromJSON = function (json) {
        var pluginJson = JSON.parse(json);
        if (!pluginJson.input) {
            console.error('wrong json format');
            return false;
        }
        try {
            if (pluginJson.name)
                this._name = pluginJson.name;
            if (pluginJson._flowType)
                this._flowType = pluginJson._flowType;
            if (pluginJson.alerts)
                this.alerts = pluginJson.alerts;
            var params_2 = pluginJson.inputList;
            this.input.paramsList.forEach(function (_a) {
                var param = _a.param, key = _a.key;
                var paramData = params_2.find(function (param) { return param.key === key; });
                if (!paramData)
                    return;
                param.setJsonParam(paramData);
            });
            var outputParams_1 = pluginJson.outputList;
            this.output.paramsList.forEach(function (_a) {
                var param = _a.param, key = _a.key;
                var paramData = outputParams_1.find(function (param) { return param.key === key; });
                if (!paramData)
                    return;
                param.setJsonParam(paramData);
            });
            this.input.updateSubscriptions();
            return true;
        }
        catch (e) {
            console.error(this.input.errors);
            return false;
        }
    };
    Plugin.prototype.inputParamsTo = function (type) {
        var values = {};
        var setParams = function (params, input) {
            for (var key in params) {
                var paramKey = key;
                var param = params[paramKey];
                if (param instanceof FctParam) {
                    input[paramKey] = type === 'VALUES' ? param.getString() : param.getJsonParam({ key: key, ioType: 'INPUT' });
                }
                else {
                    if (!input[paramKey]) {
                        input[paramKey] = {};
                    }
                    setParams(params[key], input[paramKey]);
                }
            }
        };
        setParams(this.input.params, values);
        return values;
    };
    Object.defineProperty(Plugin.prototype, "error", {
        get: function () {
            return this._error;
        },
        enumerable: false,
        configurable: true
    });
    Plugin.prototype.setError = function (e) {
        this._error = e;
        this.updateSubscriptions();
    };
    Object.defineProperty(Plugin.prototype, "currentGasLimit", {
        get: function () {
            return this._currentGasLimit;
        },
        set: function (gasLimit) {
            this._currentGasLimit = gasLimit;
            this.updateSubscriptions();
        },
        enumerable: false,
        configurable: true
    });
    Plugin.prototype.outputParamsTo = function (type) {
        var values = {};
        var output = {};
        var setParams = function (params, input) {
            for (var key in params) {
                var paramKey = key;
                var param = params[paramKey];
                if (param instanceof FctParam) {
                    output[paramKey] = type === 'VALUES' ? param.getString() : param.getJsonParam({ key: key, ioType: 'OUTPUT' });
                }
                else {
                    if (!output[paramKey]) {
                        output[paramKey] = {};
                    }
                    setParams(params[key], output[paramKey]);
                }
            }
        };
        setParams(this.output.params, values);
        return output;
    };
    return Plugin;
}());
export { Plugin };
